import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { useCart } from "../../context/CartContext";
import { Heart } from "lucide-react";
import { showError } from "../../utils/toastUtils";
import Auth from "../../utils/AuthUtils";
import wishlistAPI from "../../api/wishlistApi";

// 🌟 Yeh card CATEGORY / BRAND / SHOP / WISHLIST listing ke liye hai.
// Yahan sirf IMAGE dikhti hai (koi video nahi) — hover pe secondary gallery
// image crossfade hoti hai (pure CSS se, JS state ki zaroorat nahi).
// Trending section ka video-wala experience "TrendingCards.js" mein hai.
function Card({ item }) {
  const { addToCart, setShowCartCanvas } = useCart();
  const navigate = useNavigate();
  const { config } = useSiteConfig();

  const initialPrice = item?.productType === "Variant" ? (item?.variants?.[0]?.price ?? 0) : (item?.price ?? 0);
  const initialMrp = item?.productType === "Variant" ? (item?.variants?.[0]?.mrp ?? 0) : (item?.mrp ?? 0);
  const initialDiscount = item?.productType === "Variant" ? (item?.variants?.[0]?.discount ?? 0) : (item?.discount ?? 0);
  const initialStock = item?.productType === "Variant" ? (item?.variants?.[0]?.stock ?? 0) : (item?.stock ?? 0);

  const [image, setImage] = useState(item?.thumbnail);
  const [slug, setSlug] = useState(item?.slug);
  const [title, setTitle] = useState(item?.title);

  const [activePrice, setActivePrice] = useState(initialPrice);
  const [activeMrp, setActiveMrp] = useState(initialMrp);
  const [activeDiscount, setActiveDiscount] = useState(initialDiscount);
  const [activeStock, setActiveStock] = useState(initialStock);
  const [activeVariantId, setActiveVariantId] = useState(
    item?.productType === "Variant" && item?.variants?.length ? item?.variants[0]._id : null
  );
  const [isWishlisted, setIsWishlisted] = useState(item.isWishlisted || false);

  const secondaryImage = item?.gallery && item?.gallery.length > 0 ? item.gallery[0] : item?.thumbnail;

  useEffect(() => {
    if (item?.productType !== "Variant") return;
    const selected = item?.variants?.find((v) => v._id === activeVariantId);
    if (selected) {
      const newImg = selected.images?.[0] || item?.thumbnail;
      setImage(newImg);
      setActivePrice(selected.price);
      setActiveMrp(selected.mrp);
      setActiveDiscount(selected.discount);
      setActiveStock(selected.stock);
    }
  }, [activeVariantId, item]);

  const hasDiscount = activeDiscount !== null && activeDiscount > 0 && activeMrp > activePrice;
  const isOutOfStock = activeStock <= 0;

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      await addToCart(item?._id, 1, activeVariantId || "");
      setShowCartCanvas(true);
    } catch (err) {
      console.error(err);
    }
  };

  const handleWishlistToggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const isLoggedIn = Auth.getToken();

    if (!isLoggedIn) {
      showError("Please log in to manage your wishlist");
      return;
    }

    try {
      const res = await wishlistAPI.addProduct({ productId: item?._id });
      if (res.code === 200) {
        setIsWishlisted((prev) => !prev);
      }
    } catch (error) {
      showError("Failed to update wishlist");
    }
  };

  return (
    <div className="premium-product-card">
      <Link to={`/shop/${slug}`} className="product-card-link-wrapper">

        {/* MEDIA CONTAINER */}
        <div
          className="product-image-container position-relative overflow-hidden"
        >

          {/* 🌟 WISHLIST HEART ICON ON TOP RIGHT */}
          {!isOutOfStock && (
            <button
              type="button"
              className={`wishlist-btn ${isWishlisted ? "active" : ""}`}
              onClick={handleWishlistToggle}
              aria-label="Add to wishlist"
            >
              <Heart
                size={18}
                strokeWidth={isWishlisted ? 0 : 1.5}
                className="heart-icon"
              />
            </button>
          )}

          {/* Primary Image Layer */}
          <img
            src={image || item?.thumbnail}
            alt={title}
            loading="lazy"
            className="card-media-img primary-img"
          />

          {/* Secondary image crossfade on hover (image-only, no video here) */}
          <img
            src={secondaryImage}
            alt={`${title} alternate view`}
            loading="lazy"
            className="card-media-img secondary-img"
          />

          {/* Out Of Stock Cover */}
          {isOutOfStock && (
            <div className="oos-label-overlay">
              <span>OUT OF STOCK</span>
            </div>
          )}

          {/* 🌟 TEXT BANNER BUTTON AT BOTTOM OVERLAY */}
          {!isOutOfStock && config?.productVisibility === "cart" && (
            <button
              type="button"
              className="luxury-add-to-cart-bar"
              onClick={handleAddToCart}
            >
              ADD TO CART
            </button>
          )}

        </div>

        {/* METADATA DETAILS */}
        <div className="product-meta-details text-center">
          <h6 className="meta-title-text">{title}</h6>

          <div className="meta-price-row d-flex align-items-center justify-content-center">
            <span className="current-price-val">₹{activePrice}</span>
            {hasDiscount && (
              <>
                <span className="old-mrp-val ms-2">₹{activeMrp}</span>
                <span className="discount-percentage-val ms-2">({Math.round(activeDiscount)}% OFF)</span>
              </>
            )}
          </div>
        </div>

      </Link>
    </div>
  );
}

export default Card;